/**
 * /app/footings — list of saved footing designs (all 4 subtypes mixed).
 * The card shows the subtype as a badge so the user can tell isolated
 * from strip/combined/connected at a glance.
 */

import { FootingIcon } from '@/components/icons/FootingIcon';
import { DesignsList } from '@/features/designs/DesignsList';

export function FootingsIndexPage() {
  return (
    <DesignsList
      module="zapatas"
      description="Zapatas aisladas, corridas, combinadas y conectadas — abre una guardada o crea una nueva."
      icon={<FootingIcon size={24} />}
    />
  );
}
